<ng-container *ngIf="!!params">
    <ng-container *ngIf="params.show_prod_id_planning === '1'">
        <tt-input ttLabel="prod_id_planning" [(ttModel)]="params.prod_id_planning" ttReadonly>
            <ng-container buttons *ngIf="params.prod_id_planning > ''">
                <tt-form-field-button ttIcon="fas fa-chevron-right" ttGoto="product" [ttGotoParms]="{ prod_id: params.prod_id_planning }"></tt-form-field-button>
            </ng-container>
        </tt-input>
        <tt-search
            ttLabel="prod_name_planning"
            [(ttModel)]="params.prod_name_planning"
            [ttSearch]="searchProducts"
            (ttOnSelected)="onProductPlanningSelected($event)"
            (ttOnClear)="onProductPlanningSelected()"
        ></tt-search>
    </ng-container>
    <tt-select
        ttLabel="prodplace"
        [(ttModel)]="params.prodplace_id"
        (ttModelChange)="onChanged('prodplace_id')"
        [ttData]="productionPlaces"
        ttDataId="prodplace_id"
        ttDataName="prodplace_name"
    ></tt-select>
    <ng-container *ngIf="params.planpolicy_no === '2'">
        <tt-select
            ttLabel="pohcompletionmethod"
            [(ttModel)]="params.pohcompletionmethod_keyno"
            (ttModelChange)="onChanged('pohcompletionmethod_keyno')"
            [ttData]="completionMethods"
            ttDataId="pohcompletionmethod_keyno"
            ttDataName="pohcompletionmethod_name"
        ></tt-select>
        <tt-checkbox ttLabel="pofinish_quantity_used_required" [(ttModel)]="params.pofinish_quantity_used_required" (ttModelChange)="onChanged('pofinish_quantity_used_required')"></tt-checkbox>
        <tt-select
            ttLabel="prodbeomethod"
            [(ttModel)]="params.prodbeomethod_no"
            (ttModelChange)="onChanged('prodbeomethod_no')"
            [ttData]="productionOrderMethods"
            ttDataId="prodbeomethod_no"
            ttDataName="prodbeomethod_name"
        ></tt-select>
    </ng-container>
    <tt-input-number
        *ngIf="params.show_kit_sortorder === '1'"
        ttLabel="kit_sortorder"
        [(ttModel)]="params.kit_sortorder"
        (ttModelChange)="onChanged('kit_sortorder')"
        ttTextAlign="right"
        ttDecimals="0"
    ></tt-input-number>
    <tt-input-number
        *ngIf="params.show_waste_pst === '1'"
        ttLabel="waste_pst"
        [(ttModel)]="params.waste_pst"
        (ttModelChange)="onChanged('waste_pst')"
        ttTextAlign="right"
        ttDecimals="0"
    ></tt-input-number>
    <tt-select
        *ngIf="params.show_bookinggrp === '1'"
        ttLabel="bookinggrp"
        [(ttModel)]="params.bookinggrp_keyno"
        (ttModelChange)="onChanged('bookinggrp_keyno')"
        [ttData]="bookingGroups"
        ttDataId="bookinggrp_keyno"
        ttDataName="bookinggrp_name"
        ttShowClearButton
        [ttClearValue]="''"
    >
        <tt-form-field-button buttons ttIcon="fas fa-bars" ttGoto="collections"></tt-form-field-button>
    </tt-select>

    <ng-container *ngIf="params.planpolicy_no === '2'">
        <tt-checkbox
            ttLabel="warning_on_pick_as_component_outside_structure"
            [(ttModel)]="params.warning_on_pick_as_component_outside_structure"
            (ttModelChange)="onChanged('warning_on_pick_as_component_outside_structure')"
        ></tt-checkbox>
        <tt-checkbox ttLabel="enable_wreck_po" [(ttModel)]="params.enable_wreck_po" (ttModelChange)="onChanged('enable_wreck_po')"></tt-checkbox>
        <tt-checkbox ttLabel="integer_consumption" [(ttModel)]="params.integer_consumption" (ttModelChange)="onChanged('integer_consumption')"></tt-checkbox>
    </ng-container>
    <tt-input-number ttLabel="bookingunits" [(ttModel)]="params.bookingunits" (ttModelChange)="onChanged('bookingunits')" ttTextAlign="right" ttDecimals="2"></tt-input-number>
</ng-container>
